import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, DropdownButton, MenuItem } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { DataTable, PageHeader, SearchBar } from 'axway-react-ui';
import IntlComponent from 'axway-react-intl';
import Fuse from 'fuse.js';

const ENV_FILTER = [
	'all',
	'local',
	'default'
];

// Sort by local then default
const compare = (a = {}, b = {}) => {
	// We expect all of the object have names, this is to be careful
	if (!a.name || !b.name) {
		return 0;
	}
	if (a.name.endsWith('local.js') && b.name.endsWith('default.js')) {
		return -1;
	}
	if (a.name.endsWith('default.js') && b.name.endsWith('local.js')) {
		return 1;
	}
	if (a.name.length < b.name.length) {
		return -1;
	}
	if (a.name.length > b.name.length) {
		return 1;
	}
	return 0;
};

class ConfigurationListView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.setEnvFilter = this.setEnvFilter.bind(this);
		this.setSearchFilter = this.setSearchFilter.bind(this);
		this.applySearchFilter = this.applySearchFilter.bind(this);
		this.applyEnvFilter = this.applyEnvFilter.bind(this);

		// distance x threshold = no. of chars it will search within (starting from the left)
		this.fuseOpts = {
			threshold: 0.1,
			distance: 1000,
			keys: [ 'name' ]
		};

		this.fuse = new Fuse(props.items, this.fuseOpts);

		// Env names displayed in table.
		this.envNames = {
			local: this.intl.formatMsg('Local'),
			default: this.intl.formatMsg('Default')
		};

		// Env names displayed in filter
		this.envFilterNames = {
			...this.envNames,
			all: this.intl.formatMsg('All Environments')
		};
		this.envFilterMenu = this.buildEnvFilterMenu();

		this.state = {
			envFilter: 'all',
			searchFilter: null
		};
	}

	componentWillReceiveProps(props) {
		this.fuse = new Fuse(props.items, this.fuseOpts);
	}

	buildEnvFilterMenu() {
		return ENV_FILTER.map((key, i) => (
			<MenuItem id={`menu-env-${key}`} eventKey={key} key={i}>
				{this.envFilterNames[key]}
			</MenuItem>
		));
	}

	setEnvFilter(filter) {
		this.setState({
			envFilter: filter
		});
	}

	setSearchFilter(filter) {
		let searchFilter;
		if (filter) {
			searchFilter = filter;
		}
		this.setState({
			searchFilter
		});
	}

	applyEnvFilter(items) {
		if (!this.state.envFilter || this.state.envFilter === 'all') {
			return items.sort(compare);
		}

		return items.filter(item => {
			return item.name.endsWith(`${this.state.envFilter}.js`);
		}).sort(compare);
	}

	applySearchFilter(items) {
		if (this.state.searchFilter && items) {
			return this.fuse.search(this.state.searchFilter);
		}
		return items;
	}

	render() {
		const { loadDetail } = this.props;
		const items = this.applyEnvFilter(this.applySearchFilter(this.props.items));
		const columns = [
			{
				key: 'name',
				name: this.intl.formatMsg('Name'),
				className: 'name',
				format: (item) => {
					return (
						<a
							href={`${window.$conf.prefix}/project/configuration/${encodeURIComponent(item.name)}`}
							onClick={
								(e) => {
									e.preventDefault();
								}
							}
						>
							{item.name}
						</a>
					);
				}
			}
		];

		return (
			<div className="configuration-list-view">
				<PageHeader>
					<PageHeader.Section align="left" compact>
						<PageHeader.Title
							infoPopover={{
								id: 'configuration-info',
								description: this.intl.formatMsg('Displays the list of configuration files on the API Builder instance. You can edit the configuration files here. Note edits will trigger a server restart when saved.'),
								docLink: window.$conf.docConfUrl
							}}
						>
							{this.intl.formatMsg('Configuration Files')}
						</PageHeader.Title>
					</PageHeader.Section>
					<PageHeader.Section align="left" compact>
						<ButtonGroup className="action-group-lg">
							<DropdownButton
								id="configuration-environment-dropdown"
								bsSize="large"
								title={this.envFilterNames[this.state.envFilter]}
								onSelect={this.setEnvFilter}
							>
								{this.envFilterMenu}
							</DropdownButton>
						</ButtonGroup>
					</PageHeader.Section>
					<PageHeader.Section align="left">
						<SearchBar
							onChange={this.setSearchFilter}
							throttle={50}
						/>
					</PageHeader.Section>
					<PageHeader.Section align="left" />
				</PageHeader>
				<DataTable
					className="configuration"
					clickable
					rowClick={(e, i) => loadDetail(i)}
					columns={columns}
					items={items}
				/>
			</div>
		);
	}
}

ConfigurationListView.propTypes = {
	items: PropTypes.array.isRequired,
	loadDetail: PropTypes.func.isRequired
};

export default injectIntl(ConfigurationListView);
